module.exports = __webpack_public_path__ + "img/cooperacion.e13d5c49.jpg";